import React from 'react';
import { MoonStarIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-slateblue-900 py-10 text-slateblue-200" data-id="element-25" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-26" data-mp="3ghc0bvkn0rl2">
        <p className="flex items-center justify-center gap-2 font-display text-lg font-bold text-white" data-id="element-27" data-mp="32p5nojgp12qd">
          <MoonStarIcon className="h-5 w-5 text-coral" aria-hidden="true" data-id="element-28" data-mp="36q94b86kf2sn" />
          El Reseteo de Sueño de 72 Horas
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed" data-id="element-29" data-mp="3ucxmzw3eezab">
          Este material es de carácter educativo y no sustituye la valoración de
          un pediatra. Si tu bebé presenta problemas de salud, consulta siempre
          con un profesional médico.
        </p>
        <p className="mt-5 text-xs" data-id="element-30" data-mp="3qbvq3lwyezbi">
          © {new Date().getFullYear()} El Reseteo de Sueño de 72 Horas · Todos
          los derechos reservados
        </p>
      </div>
    </footer>;
}